import {
  Navigate,
  useLocation,
} from "react-router-dom";

export const setToken = (token) => {
  localStorage.setItem("rasyueToken", token);
};

export const fetchToken = () => {
  return localStorage.getItem("rasyueToken");
};

function tokenUserId(token) {
  if (!token) return null;
  if (token.startsWith("accessTOKEN-")) {
    return token.slice("accessTOKEN-".length);
  }
  try {
    const payloadPart = token.split(".")[1];
    const padded = payloadPart.replaceAll("-", "+").replaceAll("_", "/");
    const pad = padded.length % 4 === 0 ? "" : "=".repeat(4 - (padded.length % 4));
    const payload = JSON.parse(atob(padded + pad));
    return payload.sub;
  } catch {
    return null;
  }
}

export function RequireToken({ user_id, children }) {
  const auth = fetchToken();
  const location = useLocation();

  if (!auth) {
    return <Navigate to="/" state={{ from: location }} />;
  }
  if (String(tokenUserId(auth)) !== String(user_id)) {
    return <Navigate to="/" state={{ from: location }} />;
  }

  return children;
}
